module.exports = __webpack_public_path__ + "img/garantie-foetus.c6bc6998.svg";